module.exports = __webpack_public_path__ + "static/media/union.b2494fd4.svg";